import React, { useContext } from "react";
import { Helmet } from "react-helmet";

function Calendly() {
  return (
    <>
      <div className="calendly-inline-widget" data-url="https://calendly.com/orangedrivers/online-beratungstermin?primary_color=009fe3" style={{minWidth: 320 + 'px', height: 850 + 'px', width: 100 + '%'}}></div>
    </>
  );
}

const Beratung = () => {
  return (
      <div>
        <Helmet>
          <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
        </Helmet>
        
        {/* <div className="static-page-title">
          <h1 style={{ textAlign: "center" }}>Beratungstermin buchen</h1>
        </div> */}
        <div className="calendly-wrapper">
          <Calendly />
        </div>
      </div>
  );
};

export default Beratung;
